import React from 'react';
import { Form, Formik, FormikValues } from 'formik';
import cn from 'classnames';
import {
    convertArrayToObject,
    createYupSchema,
    getFieldValue,
} from '../../app/[locale]/admin/lib/util';
import { FormikField } from '../data/FormikField';
import { DataField } from '../data/dataType';

export const AttributesInput: React.FC<{
    attributes: unknown;
    fields: DataField[];
    locale: string;
    title: string;
    onSubmitChanges: (value: FormikValues) => void;
    onCancel: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}> = ({ attributes, fields, locale, title, onSubmitChanges, onCancel }) => {
    const translations: { [key: string]: { [key: string]: string } } = {
        fr: { saveButton: 'Confirmer', undoButton: 'Annuler' },
        en: { saveButton: 'Confirm', undoButton: 'Undo' },
    };
    const translation: { [key: string]: string } = translations[locale];

    if (attributes) {
        const DataSchema = createYupSchema(fields);

        const fieldsValues = fields.map(field => ({
            key: field.name,
            value: getFieldValue(attributes, field, locale),
        }));

        return (
            <Formik
                initialValues={convertArrayToObject(fieldsValues)}
                onSubmit={onSubmitChanges}
                validateOnChange={true}
                validationSchema={DataSchema}
            >
                {formik => {
                    return (
                        <Form className="w-full text-base">
                            <div className="flex w-full">
                                <div className="grow">
                                    <h1 className="text-2xl font-bold sm:text-xl text-primary pl-3">
                                        {title}
                                    </h1>
                                </div>
                                <div className="justify-end">
                                    <div className="pr-3 flex space-x-4">
                                        <button
                                            className="button-cancel w-32"
                                            onClick={event => onCancel(event)}
                                            type="button"
                                        >
                                            {translation.undoButton}
                                        </button>
                                        <button
                                            className={cn(
                                                'button-ok w-32 ',
                                                !formik.dirty &&
                                                    'disabled:opacity-25',
                                                !formik.isValid &&
                                                    'disabled:opacity-25 bg-red-200 hover:bg-red-400 text-gray-600 hover:text-gray-800 border-red-500 hover:border-red-500',
                                            )}
                                            disabled={
                                                !(
                                                    formik.dirty &&
                                                    formik.isValid
                                                )
                                            }
                                            type="submit"
                                        >
                                            {translation.saveButton}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="grid w-full grid-cols-1 md:grid-cols-6">
                                {fields
                                    .filter(f => f.dataType !== 'key')
                                    .map((field: DataField) => (
                                        <div
                                            className={cn(
                                                'px-3 mb-2',
                                                `col-span-full ${field.gridClass}`,
                                            )}
                                            key={field.name}
                                        >
                                            <FormikField
                                                dataField={field}
                                                dirty={formik.dirty}
                                                editable={true}
                                                errors={formik.errors}
                                                fieldList={field.dataList}
                                                locale={locale}
                                                onChanges={() => {
                                                    return null;
                                                }}
                                                touched={formik.touched}
                                                values={formik.values}
                                            />
                                        </div>
                                    ))}
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        );
    }
};
